export default __webpack_public_path__ + "static/media/quickAddDefault.2177ed24.svg";